// extracted by mini-css-extract-plugin
export default {"headerBar":"DP-z","pointsSection":"EP-z","goToDashboard":"FP-z"};